import { render, staticRenderFns } from "./approvalProcessDialog.vue?vue&type=template&id=09c4adba&scoped=true"
import script from "./approvalProcessDialog.vue?vue&type=script&lang=js"
export * from "./approvalProcessDialog.vue?vue&type=script&lang=js"
import style0 from "./approvalProcessDialog.vue?vue&type=style&index=0&id=09c4adba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c4adba",
  null
  
)

export default component.exports